<template>
  <div class="dialog">
    <div class='h100vh-160 w100vw-284 h-scroll'>
      <ejs-grid ref="noRealQueryList" :allowPaging="false" :dataSource="dataSource" :columns='columnsOfNoRealTaskQueryList' :allowResizing='true' :height="screenHeight" :width="screenWidth" :dataBound="dataBound"></ejs-grid>
    </div>
    <div>
      <ejs-pager ref='pagerOfQueryList' @click="getNoRealQueryListData" :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
    </div>
  </div>
</template>

<script>
  import DateUtil from '../../../util/DateUtil';

  export default {
    name: 'PmNoRealTaskQueryList',
    props: [
      'selectedCounterNode'
    ],
    data() {
      return {
        dataSource: [],
        columnsOfNoRealTaskQueryList: [],
        page: {
          currentPage: 1,
          pageSize: 20,
          totalRecordsCount: 0,
          pageCount: 10
        },
        screenHeight: 'calc(100vh - 200px)',
        screenWidth: '0'
      };
    },
    methods: {
      dataBound() {
        this.screenWidth = `${820 + 300 * this.selectedCounterNode.length}`;
      },
      getNoRealQueryListData(){
        this.$emit('noRealQueryListPageClick', this.$refs.pagerOfQueryList.ej2Instances.currentPage);
      },
      getColumnsOfNoRealQueryList(){
        this.columnsOfNoRealTaskQueryList = [];

        // 通用公共字段缓存
        const columnsCacheOfOrdCommonAttr = [
          {
            field: 'ne_name',
            headerText: this.$t('Pm.resource_name'),
            textAlign: 'Center',
            clipMode: 'EllipsisWithTooltip',
            width: 100,
            autoFit: true
          }, {
            field: 'statistic_cycle',
            headerText: this.$t('Pm.statistic_cycle'),
            textAlign: 'Center',
            clipMode: 'EllipsisWithTooltip',
            width: 120,
            valueAccessor: function valueAccessor (field,data){
              return data[field] / 1000;
            },
            autoFit: true
          }, {
            field: 'start_time',
            headerText: this.$t('Pm.start_time'),
            textAlign: 'Center',
            clipMode: 'EllipsisWithTooltip',
            width: 200,
            valueAccessor: function valueAccessor (field,data){
              return DateUtil.getDateString(new Date(data[field]));
            },
            autoFit: true
          }, {
            field: 'end_time',
            headerText: this.$t('Pm.end_time'),
            textAlign: 'Center',
            clipMode: 'EllipsisWithTooltip',
            width: 200,
            valueAccessor: function valueAccessor (field,data){
              return DateUtil.getDateString(new Date(data[field]));
            },
            autoFit: true
          }, {
            field: 'Intodb_time',
            headerText: this.$t('Pm.Intodb_time'),
            textAlign: 'Center',
            clipMode: 'EllipsisWithTooltip',
            width: 200,
            valueAccessor: function valueAccessor (field,data){
              return DateUtil.getDateString(new Date(data[field]));
            },
            autoFit: true
          }
        ]

        let columnsCacheOfCounter = this.selectedCounterNode.map(function (selectedCounterNode) {
          return {
            field: selectedCounterNode.id,
            headerText: selectedCounterNode.text,
            textAlign: 'Center',
            clipMode: 'EllipsisWithTooltip',
            width: 300,
            valueAccessor: function valueAccessor (field,data){
              return data[field] == undefined || data[field] == null || data[field].toString() == '' ? '—' : data[field];
            },
            autoFit: true
          }
        })

        for (let k = 0; k < columnsCacheOfOrdCommonAttr.length; k++) {
          this.columnsOfNoRealTaskQueryList.push(columnsCacheOfOrdCommonAttr[k]);
        }

        for (let k = 0; k < columnsCacheOfCounter.length; k++) {
          this.columnsOfNoRealTaskQueryList.push(columnsCacheOfCounter[k]);
        }
      }
    }
  };
</script>

<style scoped>
  .dialog >>> .e-control.e-grid .e-gridcontent.e-lib.e-droppable {
    height: calc(100vh - 204px);
  }
</style>
